import React, { useRef, useEffect, useState } from 'react';
import { useOutletContext } from 'react-router-dom';
import { isEmpty } from 'lodash';
import Clock from '../../Clock';
import styles from './styles.module.scss';
import { isMobile } from 'react-device-detect';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { toggleLeftSidebar } from '../../../redux/reducers/leftRightPanelStatus.reducer';

const LeftPanel = React.memo(({ children, customHeading = 'Views' }) => {
	const [
		leftPanelOpen,
		handleOpenLeftPanel,
		closeLeftPanel,
		rightPanelOpen,
		handleOpenRightPanel,
		closeRightPanel
	] = useOutletContext();

	const dispatch = useDispatch();

	const leftPanelStatus = useSelector((state) => state.sidebarStatus.left);
	const leftPanelRef = useRef(null);
	const toggleLeftPanelBtnRef = useRef(null);

	useEffect(() => {
		function handleLeftPanelClickOutside(event) {
			if (
				leftPanelRef.current &&
				!leftPanelRef.current.contains(event.target) &&
				!toggleLeftPanelBtnRef.current.contains(event.target) &&
				leftPanelOpen
			) {
				closeLeftPanel();
			}
		}

		document.addEventListener('mousedown', handleLeftPanelClickOutside);

		return () => {
			document.removeEventListener('mousedown', handleLeftPanelClickOutside);
		};
	}, [toggleLeftPanelBtnRef]);

	useEffect(() => {
		function focusLeftPanel(event) {
			if (event.keyCode === 76 && event.altKey) {
				const panelButtons = [...leftPanelRef.current.querySelectorAll('button, a[href]')].filter(
					(el) => !el.hasAttribute('disabled') && !el.getAttribute('aria-hidden')
				);

				if (panelButtons.length > 0) {
					panelButtons[0].focus();
				}
			}
		}

		document.addEventListener('keydown', focusLeftPanel);

		return () => {
			document.removeEventListener('keydown', focusLeftPanel);
		};
	}, []);

	return (
		<>
			{isMobile ? (
				<>
					<button
						type="button"
						className={`${styles.showLeftPanelBtn} ${leftPanelOpen ? styles.show : styles.hide}`}
						onClick={() => {
							closeRightPanel();
							handleOpenLeftPanel();
						}}
						aria-label={'Toggle Left Panel'}
						ref={toggleLeftPanelBtnRef}
					>
						{leftPanelOpen ? (
							<i className="fas fa-angle-double-left"></i>
						) : (
							<i className="fas fa-angle-double-right" style={{ color: 'blue' }}></i>
						)}
					</button>
					<nav
						id={styles.leftPanel}
						className={`${leftPanelOpen ? styles.expanded : styles.collapsed}`}
						ref={leftPanelRef}
						aria-label="Left Panel"
					>
						<div className={styles.topSection}>
							{!isEmpty(children) && <h3>{customHeading}</h3>}
						</div>
						<div className={styles.middleSection}>{children}</div>
						<div className={styles.bottomSection}>
							<Clock />
						</div>
					</nav>
				</>
			) : (
				<>
					<button
						type="button"
						className={`${styles.showLeftPanelBtn} ${leftPanelStatus ? styles.hide : styles.show}`}
						onClick={() => dispatch(toggleLeftSidebar())}
						aria-label={'Toggle Left Panel'}
						ref={toggleLeftPanelBtnRef}
					>
						{leftPanelStatus ? (
							<i className="fas fa-angle-double-right" style={{ color: 'blue' }}></i>
						) : (
							<i className="fas fa-angle-double-left"></i>
						)}
					</button>
					<nav
						id={styles.leftPanel}
						className={`${leftPanelStatus ? styles.collapsed : styles.expanded}`}
						ref={leftPanelRef}
						aria-label="Left Panel"
					>
						<div className={styles.topSection}>
							{!isEmpty(children) && <h3>{customHeading}</h3>}
						</div>
						<div className={styles.middleSection}>{children}</div>
						<div className={styles.bottomSection}>
							<Clock />
						</div>
					</nav>
				</>
			)}
		</>
	);
});

export default LeftPanel;
